import { SortLabel } from 'components/SlideGroups/Modals/components/SortLabel';
import {
  MODIFIED_DATE_SORT,
  NAME_SORT,
  SLIDES_COUNT_SORT,
} from 'components/SlideGroups/utilities/constants';
import React from 'react';
import { handleSortClick } from 'components/SlideGroups/utilities/utilities';
import { Label } from 'components/SlideGroups/Modals/components/Label';
import Box from '@mui/material/Box';

export const HeaderWithSorts = ({ sort, setSort, classes }) => (
  <Box className={classes.groupsRowContainer}>
    <SortLabel
      isActive={sort.field === NAME_SORT}
      label="Group Name"
      mode={sort.order}
      onClick={() => handleSortClick(setSort, NAME_SORT)}
      classes={classes}
    />
    <SortLabel
      isActive={sort.field === SLIDES_COUNT_SORT}
      label="Slide Count"
      mode={sort.order}
      onClick={() => handleSortClick(setSort, SLIDES_COUNT_SORT)}
      classes={classes}
    />
    <SortLabel
      isActive={sort.field === MODIFIED_DATE_SORT}
      label="Last Modified"
      mode={sort.order}
      onClick={() => handleSortClick(setSort, MODIFIED_DATE_SORT)}
      classes={classes}
    />
    <Label label="Add/Remove" classes={classes} />
  </Box>
);
